/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AdControlsDropDownEntrypointProps } from './AdControlsDropDown.entrypoint.types.tsx';

type AdControlsDropDownEntryPointComponent = EntryPointComponent<
	{},
	{},
	AdControlsDropDownEntrypointProps,
	[]
>;

export const adControlsDropDownEntryPoint: EntryPoint<AdControlsDropDownEntryPointComponent, {}> =
	createEntryPoint({
		// eslint-disable-next-line @atlassian/react-entrypoint/entrypoint-jsresource-prefer-string-module
		root: JSResourceForInteraction(async () => {
			return import(
				/* webpackChunkName: "async-jira-adcontrols-dropdown" */ './AdControlsDropDown.tsx'
			);
		}),
		getPreloadProps: () => ({}),
	});
